import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  createTheme,
  IconButton,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getUserTypes } from "../../../../api/userType";
import { Autocomplete } from "@material-ui/lab";
import { getCursoById, updateCurso } from "../../../../api/curso";
import { getUsers } from "../../../../api/user";
import { PersonAdd } from "@material-ui/icons";
import { UserFormModal } from "../../../components/UserFormModal";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyInscripcion() {
  return {
    pagado: "",
    aprovado: "Sin asignar",
    user: "",
    fechaPago: "",
    esDocente: false,
    obs: "",
    active: true,
  };
}

export default function EditInscripcionPage() {
  const [inscripcion, setInscripcion] = useState(getEmptyInscripcion());
  const [curso, setCurso] = useState({});
  const [users, setUsers] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openModalAddUser, setOpenModalAddUser] = useState(false);
  const [refreshUsers, setRefreshUsers] = useState(false);
  const inscripcionId = useParams().id;
  const cursoId = useParams().cursoId;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resUsers = await getUsers();
        if (resUsers.status === 200) {
          setUsers(
            resUsers.data.filter((x) => x.role != "admin" && x.role != "gestor")
          );
        }
        const resUserTypes = await getUserTypes();
        if (resUserTypes.status === 200) {
          setUserTypes(resUserTypes.data);
        }
        getCursoById(cursoId)
          .then((res) => {
            if (res.status === 200) {
              setCurso(res.data);
              if (inscripcionId) {
                setInscripcion(
                  res.data.inscripciones?.find((x) => x._id === inscripcionId)
                );
                setSelectedUser(
                  resUsers.data.find(
                    (x) =>
                      x._id ===
                      res.data.inscripciones?.find(
                        (x) => x._id === inscripcionId
                      )?.user
                  )
                );
              }

              disableLoadingData();
            }
          })
          .catch((error) => {
            alertError({
              error: error,
              customMessage: "Could not get inscripcion.",
            });
            history.push("/cursos");
          });
      } catch (error) {}
    };
    fetchData();
  }, [cursoId, inscripcionId, disableLoadingData, history]);

  useEffect(() => {
    setRefreshUsers(false);
  }, [refreshUsers]);

  function saveInscripcion() {
    let saveCurso = curso;
    let saveInscripcion = inscripcion;
    saveInscripcion.user = selectedUser._id;
    if (inscripcionId) {
      saveCurso = {
        ...saveCurso,
        inscripciones: saveCurso.inscripciones.map((item) =>
          item._id === inscripcionId ? saveInscripcion : item
        ),
      };
    } else {
      if (!Array.isArray(saveCurso.inscripciones)) {
        saveCurso.inscripciones = [];
      }
      saveCurso.inscripciones.push(saveInscripcion);
    }
    updateCurso(cursoId, saveCurso)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          history.push("/edit-curso/" + cursoId + "?tab=inscripciones");
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not save changes.",
        });
      });
  }

  const handleChange = (element) => (event) => {
    setInscripcion({ ...inscripcion, [element]: event.target.value });
  };

  const onSave = (user) => {
    users.push(user.user);
    setSelectedUser(user.user);
    setRefreshUsers(true);
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () =>
              history.push("/edit-curso/" + cursoId + "?tab=inscripciones"),
            onSave: saveInscripcion,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!inscripcionId,
            setObj: setInscripcion,
            obj: inscripcion,
          })}
          <CardHeader title="Editar Precio"></CardHeader>
          <CardBody>
            <div className="d-flex">
              <div className="col-md-4">
                <div className="d-flex">
                  <div className="col-md-2">
                    <IconButton
                      color="primary"
                      onClick={() => setOpenModalAddUser(true)}
                    >
                      <PersonAdd />
                    </IconButton>
                  </div>
                  <div className="col-md-10">
                    {!refreshUsers && (
                      <Autocomplete
                        className="w-100 mr-5"
                        id="autocomplete-familia"
                        filterSelectedOptions
                        options={users}
                        getOptionLabel={(option) =>
                          (option?.fullName || "") + " " + (option?.dni || "")
                        }
                        value={selectedUser || ""}
                        onChange={(event, selected) => {
                          setSelectedUser(selected);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Seleccionar usuario"
                          />
                        )}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <Autocomplete
                  className="w-100 mr-5"
                  id="autocomplete-familia"
                  options={["Pendiente", "Pagado", "Rechazado"]}
                  // getOptionLabel={(option) => option?.fullname + " " + option?.dni}
                  value={inscripcion.pagado || ""}
                  onChange={(event, selected) => {
                    setInscripcion({ ...inscripcion, pagado: selected });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Seleccionar estado del pago"
                    />
                  )}
                />
              </div>
              <div className="col-md-4">
                <Autocomplete
                  className="w-100 mr-5"
                  id="autocomplete-familia"
                  options={["Sin asignar", "Si", "No"]}
                  // getOptionLabel={(option) => option?.fullname + " " + option?.dni}
                  value={inscripcion.aprovado || "Sin asignar"}
                  onChange={(event, selected) => {
                    setInscripcion({ ...inscripcion, aprovado: selected });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Seleccionar aprovado"
                    />
                  )}
                />
              </div>
            </div>
            <div className="d-flex">
              <div className="col-md-4">
                <TextField
                  id={`fechaPago`}
                  label="Fecha del pago"
                  value={inscripcion.fechaPago}
                  onChange={handleChange("fechaPago")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  type="date"
                />
              </div>
              <div className="col-md-6">
                <TextField
                  id={`obs`}
                  label="Observaciones"
                  value={inscripcion.obs}
                  onChange={handleChange("obs")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  multiline
                  variant="outlined"
                />
              </div>
            </div>

            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={inscripcion.active || false}
                    onChange={() =>
                      setInscripcion({ ...inscripcion, active: !inscripcion.active })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
            </div>
          </CardBody>
        </Card>

        {inscripcionId && (
          <>
            <ConfirmDialog
              title={"Are you sure you want to delete this inscripcion?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                let saveCurso = {
                  ...curso,
                  inscripciones: curso?.inscripciones?.filter(
                    (x) => x._id !== inscripcionId
                  ),
                };
                updateCurso(cursoId, saveCurso)
                  .then((res) => {
                    if (res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Inscription deleted",
                      });
                      history.push(
                        "/edit-curso/" + cursoId + "?tab=inscripciones"
                      );
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not save changes.",
                    });
                  });
              }}
            />
          </>
        )}
        <UserFormModal
          open={openModalAddUser}
          setOpen={setOpenModalAddUser}
          onSave={onSave}
          userTypes={userTypes}
        />
      </>
    );
}
